// Backend envelope is always { status: <httpish code>, message, data }, even on a
// 200 HTTP response — status is a number (200 on success), not a boolean.
export const isApiSuccess = (data) => !!data && data.status === 200;
